import clsx from "clsx";
import React from "react";

interface Props {
  visible: boolean;
  children?: JSX.Element;
}

function Banner({ children, visible }: Props) {
  return (
    <div
      className={clsx("transition-all duration-500 overflow-hidden", {
        "max-h-[300px] ease-out": !visible,
        "max-h-0 ease-in": visible,
      })}
    >
      {children}
    </div>
  );
}

function Block({ children, visible }: Props) {
  return (
    <div
      className={clsx("transition-all duration-1000 overflow-hidden", {
        "max-h-[3000px] ease-out": visible,
        "max-h-0 ease-in": !visible,
      })}
    >
      {children}
    </div>
  );
}

export const AnimationContainer = {
  Banner,
  Block,
};
